module.exports = __webpack_public_path__ + "img/hut-6968718_1280_thumb.ca2300e4.png";